import { useState, useEffect, useCallback } from "react";
import { uid, parseObjectValue, entriesToObject } from "../utils";

export function useServiceFormHook(data, onChange) {
  const [kvList, setKvList] = useState(() => parseObjectValue(data.externalGroup));
  const externalGroupKey = JSON.stringify(data.externalGroup ?? {});

  useEffect(() => {
    const fromData = parseObjectValue(data.externalGroup);
    const fromListObj = entriesToObject(kvList);
    const fromDataObj = entriesToObject(fromData);
    if (JSON.stringify(fromDataObj) !== JSON.stringify(fromListObj)) {
      setKvList(fromData);
    }
  }, [externalGroupKey, data.externalGroup, kvList]);

  const syncExternalGroup = useCallback(
    (newList) => {
      setKvList(newList);
      onChange({ ...data, externalGroup: entriesToObject(newList) });
    },
    [data, onChange]
  );

  const addKvRow = useCallback(() => {
    const newList = [...kvList, { id: String(uid()), key: "", value: "" }];
    syncExternalGroup(newList);
  }, [kvList, syncExternalGroup]);

  const removeKvRow = useCallback(
    (id) => {
      const newList = kvList.filter((row) => row.id !== id);
      syncExternalGroup(newList);
    },
    [kvList, syncExternalGroup]
  );

  const updateKvRow = useCallback(
    (id, field, val) => {
      const newList = kvList.map((row) => (row.id === id ? { ...row, [field]: val } : row));
      syncExternalGroup(newList);
    },
    [kvList, syncExternalGroup]
  );

  return { kvList, addKvRow, removeKvRow, updateKvRow };
}
